import React from 'react';
import { 
  ReferenceInput, ReferenceField, 
  Labeled, ImageInput, ImageField, 
  useInput 
} from "react-admin";


export const ReferenceImageInput = props => {

  const { source, preview, label, ...rest } = props

  // 이미지 변경 텍스트 스타일 TODO 

  const isEmpty = props.record[source] == null;
  
  return (
    <>
    <ReferenceField source={source} label={label} {...rest} link={false}>
        <ImageField source={preview} title="title" link={false} onClick={()=>window.open(document.querySelector(`#${source}>img`).src)}/>
    </ReferenceField>
    <ImageInput label={isEmpty ? '' : label + ' 이미지 변경'} source={source + '__Ref'} allowEmpty>
        <ImageField source="src" />
    </ImageInput>
    </>
  )
}

export const transformReferenceImage = data => {
  // data provider 쪽에서 처리하도록 로직 변경됨 
  // 추후 수정 등 이유로 유지 
  /* Object.keys(data).filter(k => k.endsWith('__Ref'))
    .forEach(k => {
      if (data[k].length > 0) {
        data[k] = data[k][0];
      }
      else {
        data[k] = null;
      }
    }); */
  return data;
}

/* export const ReferenceImageInput_ = props => {
  console.log(props)

  const { 
      choices,
      input,
      ...rest 
  } = props;

  const {
    value, 
    ...restInput
  } = input;

  const defaultValue = choices.find(f => f.id === props.input.value);

  return (
      <ImageInput 
          defaultValue={defaultValue}
          multiple={false}
          {...rest}
          input={{ value: defaultValue, ...restInput }}
          >
          <TestImageField source="fullPath" />
      </ImageInput>
  )
}

export const ReferenceImageInput = props => {
  console.log(props)

  const {
    record, source, resource
  } = props;

  // TODO useInput 



  return (
    <ImageInput
      // source={source + '__Ref'}
      label={props.label}
      // source={source}
      // resource={resource}
      source="logoFile__Ref"
      resource="suppliers"
      defaultValue={record}
      multiple={false}
    >
      <TestImageField source="fullPath" />
    </ImageInput>
  );
}

const TestImageField = (props) => {

  console.log(props)

  return (
    <ImageField {...props} />
  )
} */
